import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import useWrapper from "../../hooks/useWrapper";

// Route guard: renders child routes only when the logged-in user has the given
// permission (permissions[group][action]) or passes the custom `check` predicate.
export default function RequirePermission({ group, action, check }) {
  const { permissions } = useWrapper();
  // Forward whatever context an ancestor layout (TraineeLayout, GroupLayout, ...) passed via its
  // own <Outlet context={...}>. Outlet always re-provides an OutletContext — even with no `context`
  // prop — so without this, nesting this guard inside a layout would reset it to undefined for
  // every route rendered below it.
  const outletContext = useOutletContext();

  const allowed = check ? !!check(permissions) : !!permissions?.[group]?.[action];

  return allowed ? <Outlet context={outletContext} /> : <Navigate to="/no-permission" replace />;
}
